// extracted by mini-css-extract-plugin
module.exports = {"text":"KcSafety_text__LWSJL","icon":"KcSafety_icon__9_lK5"};